import React from "react";
import { SvgIcon, SvgIconProps, useTheme } from "@mui/material";

const FavouriteSvg = ({ filled }: { filled: boolean }) => {
    const theme = useTheme()
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="20" height="20">
            <path fill={filled ? theme.palette.primary.main : "none"} stroke={filled ? theme.palette.primary.main : "currentColor"} strokeWidth={1}
                d="M4.5 2C3.68 2 3 2.68 3 3.5v10.98l5-3.66 5 3.66V3.5c0-.82-.68-1.5-1.5-1.5H4.5Z"></path>
        </svg>
    )
}

const FavouriteIcon: React.FC<SvgIconProps & { filled: boolean }> = React.memo(({ filled, ...props }) => (
    <SvgIcon {...props}>
        <FavouriteSvg filled={filled} />
    </SvgIcon>
));
export default FavouriteIcon